<script setup lang="ts">
import TableFooterBar from '@/components/bars/TableFooterBar.vue';
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  isSubmitting?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isSubmitting: false,
});

const emit = defineEmits<{
  clearForm: [];
}>();
</script>

<template>
  <TableFooterBar>
    <div :class="$style.jobBookingFooterBar" data-testid="jobBookingFooterBar">
      <KBtn
        variant="outlined"
        :disabled="props.isSubmitting"
        @click="emit('clearForm')"
      >
        Clear form
      </KBtn>
      <div :class="$style.actions">
        <slot />
      </div>
    </div>
  </TableFooterBar>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.jobBookingFooterBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 2.25rem;
}

.actions {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}
</style>
